import './index.css'
import clsx from 'clsx'

import React from 'react'
import Button from 'components/ui/button'

const AutoTaggingBanner = ({
  auto_tagging_tracks_sent,
  auto_tagging_tracks_limit,
  autoTaggedTracksTrial,
  videoSrc = 'https://static.disco.ac/disco-app/videos/auto_tagging_blank_state.mp4',
  isTrial,
}: {
  auto_tagging_tracks_sent: number
  auto_tagging_tracks_limit: number
  autoTaggedTracksTrial: boolean
  videoSrc?: string
  isTrial: boolean
}): React.ReactElement<'div'> => {
  const isEmptyChannel = auto_tagging_tracks_sent === 0
  const video = (
    <div className="AutoTaggingBanner_VideoContainer">
      <video
        className="AutoTaggingBanner_Video"
        autoPlay
        playsInline
        loop
        muted
      >
        <source src={videoSrc} type="video/mp4" />
        Sorry, your browser doesn’t support embedded videos.
      </video>
    </div>
  )
  const trialContent = (
    <div>
      <div className="AutoTaggingBanner_Container">
        {isEmptyChannel && video}
        <h2 className="AutoTaggingBanner_Title">
          100% of your catalog tagged. 0% of the work
        </h2>{' '}
        {isEmptyChannel && !isTrial && (
          <>
            <p className="AutoTaggingBanner_Description">
              DISCO’s auto-tagging tags your tracks and includes them in
              Similarity Search, making them more searchable. To try out
              auto-tagging, just drag some tracks into this channel.
            </p>{' '}
            <p className="AutoTaggingBanner_Description">
              You can tag up to{' '}
              {auto_tagging_tracks_limit ? (
                <span>{auto_tagging_tracks_limit}</span>
              ) : (
                <span>unlimited</span>
              )}{' '}
              <span>tracks during your trial. Check our </span>
              <a
                className="AutoTaggingBanner_Link"
                href="https://support.disco.ac/home/discovery-suite-guide"
                target="_blank"
                rel="noopener noreferrer"
              >
                Discovery Suite FAQ and pricing.
              </a>{' '}
            </p>
          </>
        )}
        {isEmptyChannel && isTrial && (
          <>
            <p className="AutoTaggingBanner_Description">
              DISCO’s auto-tagging tags your tracks and includes them in
              Similarity Search, making them more searchable. To try out
              auto-tagging, just drag some tracks into this channel.
            </p>{' '}
            <p className="AutoTaggingBanner_Description">
              You can tag up to 20 tracks during your trial. Check our{' '}
              <a
                className="AutoTaggingBanner_Link"
                href="https://support.disco.ac/home/discovery-suite-guide"
                target="_blank"
                rel="noopener noreferrer"
              >
                Discovery Suite FAQ and pricing.
              </a>
            </p>{' '}
            <p className="AutoTaggingBanner_Description">
              To subscribe to Discovery Suite, first subscribe to a base plan,
              and then contact us to add on the Discovery Suite.{' '}
            </p>{' '}
          </>
        )}
        {(!isTrial || isEmptyChannel) && (
          <div className={clsx('AutoTaggingBanner_Container')}>
            <Button
              compact
              className="AutoTaggingBanner_Button"
              appearance="primary"
              link="/settings/billing"
              caption={
                isTrial ? 'Subscribe to DISCO' : 'Subscribe to Discovery Suite'
              }
            />
          </div>
        )}
      </div>
    </div>
  )

  if (!autoTaggedTracksTrial && !isTrial && isEmptyChannel) {
    return (
      <div className="AutoTaggingBanner AutoTaggingBanner--BlankChannel">
        {video}
        <h2 className="AutoTaggingBanner_Title">
          100% of your catalog tagged. 0% of the work
        </h2>
        <p className="AutoTaggingBanner_Description">
          DISCO’s auto-tagging tags your tracks and includes them in Similarity
          Search, making them more searchable. To try out auto-tagging,{' '}
          <b>just drag some tracks into this channel.</b>
        </p>{' '}
      </div>
    )
  }

  return (
    <div className="AutoTaggingBanner AutoTaggingBanner--BlankChannel">
      {trialContent}
    </div>
  )
}

export default AutoTaggingBanner
